import { initGraphQLTada } from 'gql.tada'
import type { introspection } from './connect-env.d.ts'
import type { ConnectScalars } from './scalars'

/**
 * Tagged GraphQL function for the Connect service (the public integration API the ui reaches
 * through its `/api/connect` proxy, `CONNECT_ENDPOINT` on the server).
 *
 * Works like {@link graphql} but infers types from the committed `connect.graphql`. Its documents
 * live in separate files (`graphql/connect` in the ui) so the editors' GraphQL plugin can tell
 * the two schemas apart.
 */
export const graphqlConnect = initGraphQLTada<{
  introspection: introspection
  scalars: ConnectScalars
}>()
